module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/book_detail_09-f12f0889b54eb22e0409ef5d8e02b786.png";